export const reviewsRouteNames = {
  NewReview: 'reviews/new-review',
  EditReview: 'reviews/edit-review'
}
